import * as types from './types'

import axios from 'axios'

export const loadSearchNews = ({commit}) => {
  commit(types.BEGIN_AJAX_CALL)
  axios.get(`${window.API_URL}/search${window.location.search}`)
    .then(({data}) => {
      commit(types.RECEIVE_SEARCH_NEWS, data)
      commit(types.AJAX_CALL_SUCCESS)
    })
    .catch(() => {
      commit(types.AJAX_CALL_ERROR)
    })
}

export const selectCategory = ({commit}, category) => {
  commit(types.RECEIVE_SELECT_CATEGORY, category)
}



// WEBPACK FOOTER //
// ./src/app/config/store/modules/search/actions.js